import { DeleteOutlined } from '@ant-design/icons'
import { Popconfirm, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { MISSION_STATUS, TYPE_STATUS } from '../../../constants'
import { EmptyText } from '../CellText'
import { StatusTag } from '../StatusTag'
import {
  TaskedContent,
  TaskedItem,
  TaskedLink,
  TaskedWrapper,
} from './LinkedStyled'

const LinkedTask = props => {
  const {
    linkedTaskList,
    documentCode,
    internalDocumentStore,
    onSuccess,
  } = props

  const handleUnlinkTask = async taskCode => {
    try {
      await internalDocumentStore.unlinkTask(documentCode, taskCode)
      message.success('Đã xóa liên kết nhiệm vụ')
      if (onSuccess) await onSuccess()
    } catch (error) {
      message.error('Xóa liên kết thất bại')
    }
  }

  return (
    <TaskedWrapper>
      {linkedTaskList && linkedTaskList.length > 0 ? (
        linkedTaskList.map(task => (
          <TaskedItem
            key={task.task_code}
            style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <TaskedLink
              style={{ flex: 1, minWidth: 0 }}
              onClick={() =>
                window.open(`/mission/view/${task.task_code}`, '_blank')
              }>
              <TaskedContent>
                <p>{`Chủ trì: ${task.name_user}`}</p>
                <div className="task-progress">
                  {task.phan_tram_hoan_thanh}%
                  {StatusTag(
                    TYPE_STATUS.MISSION,
                    task.phan_tram_hoan_thanh === '100'
                      ? MISSION_STATUS.COMPLETE
                      : task.phan_tram_hoan_thanh === '0' ||
                        task.phan_tram_hoan_thanh === null
                      ? MISSION_STATUS.PENDING
                      : MISSION_STATUS.IN_PROGRESS
                  )}
                </div>
              </TaskedContent>
            </TaskedLink>
            {documentCode && (
              <Popconfirm
                title={'Xác nhận xóa liên kết nhiệm vụ này?'}
                okText={'Xóa'}
                cancelText={'Hủy'}
                okButtonProps={{ danger: true }}
                onConfirm={() => handleUnlinkTask(task.task_code)}>
                <DeleteOutlined
                  style={{
                    fontSize: 13,
                    color: '#ff4d4f',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                />
              </Popconfirm>
            )}
          </TaskedItem>
        ))
      ) : (
        <EmptyText>Không có.</EmptyText>
      )}
    </TaskedWrapper>
  )
}

export default inject('internalDocumentStore')(observer(LinkedTask))
